// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"4d7f4160","583":"94abe9f9","702":"72c7baf2","756":"cbee8e75","908":"83e1ebc9"}[chunkId] + ".chunk.js";
};